
import { Prop, Watch, Component, Vue } from 'vue-property-decorator'
import { getResourceList } from '@/api'
import { Resource } from '@/types/type'
@Component({
    name: 'QuestionContents'
})
export default class extends Vue {
    @Prop(String) readonly id!: string
    private resourceList: Resource[] = []
    private categoryName = ''
    @Watch('id')
    private async onIdChange() {
        if (this.id) {
            const res = await getResourceList(this.id)
            this.resourceList = res.data.list
            this.categoryName = this.resourceList.length ? this.resourceList[0].categoryName : ''
        }
    }
    private goDetail(id: string) {
        this.$jump(`/Question/QuestionDetail?questionId=${id}`)
    }
    async created() {
        this.onIdChange()
    }
}

